import {ValidatorFn} from '@angular/forms';

import {SignalFormControl} from './signal-form.model';

export type ISignalFormControlValidation = {
	name: string;
	validator: ValidatorFn;
	description: string;
	errorMessage: string;
	successMessage: string;
};

export class SignalFormControlValidation implements ISignalFormControlValidation {
	public name: string;
	public validator: ValidatorFn;
	public description: string;
	public errorMessage: string;
	public successMessage: string;

	constructor(init: ISignalFormControlValidation) {
		Object.assign(this, init);
	}

	public isInvalid(signalFormControl: SignalFormControl): boolean {
		const validator = signalFormControl._fc.validator;
		if (!validator) return false;
		const errors = validator(signalFormControl._fc);
		return Boolean(errors);
	}
}
